import { render, staticRenderFns } from "./PaymentMethodCheckboxField.vue?vue&type=template&id=24197acd&"
import script from "./PaymentMethodCheckboxField.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodCheckboxField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports